import { createBrowserHistory } from 'history'

import getConstants from './constants'

const CONSTANTS = getConstants()

const history = createBrowserHistory({
  basename: CONSTANTS.BASE_NAME,
})

export default history
